import Joi from '@hapi/joi';
import { PHONE_VERIFICATION_CODE_LENGTH } from '../../../../../constants/common';
import { PatientOtpDto } from '../../../../../types/api-types';

export const confirmationInputsSchema = Joi.object<
  PatientOtpDto
>({
  otp: Joi.string().required().min(PHONE_VERIFICATION_CODE_LENGTH).max(PHONE_VERIFICATION_CODE_LENGTH),
});
